module.exports = __webpack_public_path__ + "img/modified.a8b6910c.svg";